import * as stylex from '@stylexjs/stylex';
import { typography } from '../styles/typography';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { PageSectionsContentSection } from '@/tina/__generated__/types';
import { tinaField } from 'tinacms/dist/react';
import { RichText } from './RichText';
type Typography = keyof typeof typography;
const HEADING_STYLES = {
  hero: 'display1',
  regular: 'display2'
};
export interface SectionHeadingProps {
  data?: PageSectionsContentSection;
  headingType?: 'hero' | 'regular';
  styles?: stylex.StyleXStyles;
}
export function SectionHeading({
  data,
  styles,
  headingType = 'regular'
}: SectionHeadingProps) {
  const headingTextStyle = HEADING_STYLES[headingType] as Typography;
  return data ? <div {...stylex.props(sx.root, styles)}>
      {data?.eyebrow && <div className="xgqtt45">
          <p data-tina-field={tinaField(data, 'eyebrow')} {...stylex.props(typography.eyebrowRegular, sx.eyebrow)}>
            {data?.eyebrow}
          </p>
        </div>}
      <h1 data-tina-field={tinaField(data, 'heading')} {...stylex.props(typography[headingTextStyle], sx.heading)}>
        {data?.heading}
      </h1>
      {data?.subheading && <RichText wrapperStyles={sx.subheading} data-tina-field={tinaField(data, 'subheading')}>
          {data.subheading}
        </RichText>}
    </div> : null;
}
const sx = {
  root: {
    kOIVth: "xkr635c",
    kGNEyG: "x1pha0wt",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  eyebrow: {
    k1xSpc: "x1rg5ohu",
    $$css: true
  },
  heading: {
    kCS8Yb: "x1t1x2f9",
    kzQI83: "x1iyjqo2",
    kmuXW: "xs83m0k",
    kN2L0X: "x1w2vvpw",
    k7Eaqz: "xqze5w7",
    kpe85a: "x1c8wgav",
    $$css: true
  },
  subheading: {
    kCS8Yb: "x1t1x2f9",
    kzQI83: "x1iyjqo2",
    kmuXW: "xs83m0k",
    kN2L0X: "x1fzhlzt",
    k7Eaqz: "x1esio5o",
    $$css: true
  }
};